import { createAction } from '@reduxjs/toolkit';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { toast } from 'react-toastify';
import api from '../../utils/api';

export const receiveThreads = createAction('threads/receive');
export const addThread = createAction('threads/add');
export const upVoteThread = createAction('threads/upVote');
export const downVoteThread = createAction('threads/downVote');
export const neutralVoteThread = createAction('threads/neutralVote');

export function receiveThreadActionCreator(threads) {
  return receiveThreads({ threads });
}

export function addThreadActionCreator(thread) {
  return addThread({ thread });
}

export function upVoteThreadActionCreator({ threadId, userId }) {
  return upVoteThread({ threadId, userId });
}

export function downVoteThreadActionCreator({ threadId, userId }) {
  return downVoteThread({ threadId, userId });
}

export function neutralVoteThreadActionCreator({ threadId, userId }) {
  return neutralVoteThread({ threadId, userId });
}

export function asyncAddThread({ title, body, category }) {
  return async (dispatch) => {
    let isSuccess;
    dispatch(showLoading());
    try {
      const thread = await api.createThreads({ title, body, category });
      dispatch(addThreadActionCreator(thread));
      toast.success('Thread created successfully');
      isSuccess = true;
    } catch (error) {
      toast.error(error.message);
      isSuccess = false;
    }
    dispatch(hideLoading());
    return isSuccess;
  };
}

export function asyncUpVoteThread(threadId) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.upVoteThread(threadId);
      dispatch(upVoteThreadActionCreator({ threadId, userId }));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}

export function asyncDownVoteThread(threadId) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.downVoteThread(threadId);
      dispatch(downVoteThreadActionCreator({ threadId, userId }));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}

export function asyncNeutralVoteThread(threadId) {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const { userId } = await api.neutralVoteThread(threadId);
      dispatch(neutralVoteThreadActionCreator({ threadId, userId }));
    } catch (error) {
      toast.error(error.message);
    }
    dispatch(hideLoading());
  };
}
